//@ts-expect-error FormattedDuration does not have a TS implementation.
import FormattedDuration from 'I18n/components/FormattedDuration';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CLOSE_TICKET_SLA } from 'conversations-thread-data/tickets/public/constants';
import { getIsDueInLessThanEightHours, getIsDueTomorrow, dueDateBreached, isDueToday } from '../operators/dueDateComparators';
import { useCurrentTime } from '../hooks/useCurrentTime';
import { jsx as _jsx } from "react/jsx-runtime";
const SLADueDate = ({
  slaCategory,
  dueDate
}) => {
  const {
    currentTime
  } = SLADueDate.useComponent();
  const dueDateObject = new Date(dueDate);
  const verbComponent = slaCategory === CLOSE_TICKET_SLA ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "svh-workspace-ui-lib.ticket-toolbar.SLAs.SLAVerbs.timeToClose"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "svh-workspace-ui-lib.ticket-toolbar.SLAs.SLAVerbs.timeToFirstResponse"
  });
  if (dueDateBreached(currentTime, dueDate)) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "svh-workspace-ui-lib.ticket-toolbar.SLAs.dueDateBreached",
      options: {
        verb: verbComponent
      }
    });
  }
  if (getIsDueInLessThanEightHours(dueDate, currentTime)) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "svh-workspace-ui-lib.ticket-toolbar.SLAs.dueWithinDuration",
      options: {
        verb: verbComponent,
        duration: /*#__PURE__*/_jsx(FormattedDuration, {
          to: dueDate,
          includeAffix: true
        })
      }
    });
  }
  if (getIsDueTomorrow(currentTime, dueDateObject)) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "svh-workspace-ui-lib.ticket-toolbar.SLAs.dueByTommorow",
      options: {
        verb: verbComponent,
        time: /*#__PURE__*/_jsx(FormattedDateTime, {
          value: dueDate,
          format: "LT",
          type: "userTz"
        })
      }
    });
  }
  const dueDateStringFormat = isDueToday(currentTime, dueDateObject) ? 'LT' : 'short-date';
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "svh-workspace-ui-lib.ticket-toolbar.SLAs.dueBySpecificTime",
    options: {
      verb: verbComponent,
      timeOrDate: /*#__PURE__*/_jsx(FormattedDateTime, {
        value: dueDate,
        format: dueDateStringFormat,
        type: "userTz"
      })
    }
  });
};
SLADueDate.useComponent = useCurrentTime;
SLADueDate.displayName = 'SLADueDate';
export default SLADueDate;